<template>
  <div class="w_100per">
    <ul class="select-list">
      <li>
        <a class="select-item" :class="selecttab === 1 ? 'active' : ''" tabindex="0" @click="onClickTab(1)">
          <slot name="firstitem"></slot>
        </a>
      </li>
      <li>
        <a class="select-item" :class="selecttab === 2 ? 'active' : ''" tabindex="0" @click="onClickTab(2)">
          <slot name="seconditem"></slot>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    selecttab: {
      type: Number,
      default: 1,
      required: false
    }
  },
  emits: ['click-tab'],
  methods: {
    onClickTab(tabVal) {
      this.$emit('click-tab', tabVal);
    }
  }
};
</script>
<style scoped src="@/assets/css/common/commonselecttab.css"></style>
